import React from 'react';
// import PropTypes from 'prop-types';
import Stamp from '@/assets/images/share/stamp@3x.png';
import './style.less';

class Work extends React.Component {
  // static propTypes = {
  // };
  constructor() {
    super();
    this.from = React.createRef();
    this.to = React.createRef();
    this.content = React.createRef();
  }

  getValue = () => {
    const data = {
      from: this.from.current.value,
      to: this.to.current.value,
      content: this.content.current.value,
    };
    return data;
  }

  settValue = (from, to, content) => {
    this.from.current.value = from;
    this.to.current.value = to;
    this.content.current.value = content;
  }

  setDisabled = () => {
    this.from.current.disabled = true;
    this.to.current.disabled = true;
    this.content.current.disabled = true;
  }

  handleBlur = () => {
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 100);
  }

  render() {
    return (
      <div className="work-wrapper">
        <div className="from">
          <span>From:</span>
          <input type="text" maxLength="8" onBlur={this.handleBlur} ref={this.from} />
        </div>
        <div className="to">
          <span>To:</span>
          <input type="text" maxLength="8" onBlur={this.handleBlur} ref={this.to} />
        </div>
        <textarea ref={this.content} maxLength="150" onBlur={this.handleBlur} />
        <img className="stamp" src={Stamp} alt="" />
      </div>
    );
  }
}

export default Work;
